var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlinePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895432 0.89543 0 2 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.895431 16 0 15.1046 0 14V2ZM18 2L2 2V14H18V2Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.6001C0 5.04781 0.447715 4.6001 1 4.6001H19C19.5523 4.6001 20 5.04781 20 5.6001C20 6.15238 19.5523 6.6001 19 6.6001H1C0.447715 6.6001 0 6.15238 0 5.6001Z",
    fill: "#8993A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 9.44771 4.44772 9 5 9H7C7.55228 9 8 9.44771 8 10C8 10.5523 7.55228 11 7 11H5C4.44772 11 4 10.5523 4 10Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePayment);
export default __webpack_public_path__ + "static/media/online-payment.601edba69b877480febd6020a30ed0a9.svg";
export { ForwardRef as ReactComponent };